<template>
  <div v-if="groups_localized.length">
    <div>
      <div class="page_title">
        <div class="page_title-text">
          <span is="i18n">
            <span lang="ru">Актуальные вакансии</span>
            <span lang="en">Current vacancies</span>
            <span lang="kk">Өзекті бос жұмыс орындары</span>
          </span>
        </div>
      </div>
      <div class="job_openings">
        <div
          class="job_opening_card"
          :class="{ active: groups_localized[key].active }"
          v-for="(group, key) in groups_localized"
          :key="key"
        >
          <div class="job_opening_card_preview">
            <div class="job_opening_card_preview-image">
              <img :src="group.image" />
            </div>
            <div class="job_opening_card_preview_block-main">
              <div class="job_opening_card_preview_block-title">
                <span is="i18n">
                  <span lang="kk">{{ group.name }}</span>
                </span>
              </div>
              <div class="job_opening_card_preview_block-subtext">
                <span is="i18n">
                  <span lang="kk">{{ group.description }}</span>
                </span>
              </div>
            </div>
            <div class="job_opening_card_preview_block job-status">
              <div class="job_opening_card_preview_block-title">
                <span is="i18n">
                  <span lang="ru">Статус</span>
                  <span lang="en">Status</span>
                  <span lang="kk">Күйі</span>
                </span>
              </div>
              <div class="job_opening_card_preview_block-subtext">
                <span is="i18n">
                  <span lang="kk">{{ group.status }}</span>
                </span>
              </div>
            </div>
            <div class="job_opening_card_preview_block job-exp">
              <div class="job_opening_card_preview_block-title">
                <span is="i18n">
                  <span lang="ru">Опыт работы</span>
                  <span lang="en">Work experience</span>
                  <span lang="kk">Жұмыс тәжірибесі</span>
                </span>
              </div>
              <div class="job_opening_card_preview_block-subtext">
                <span is="i18n">
                  <span lang="kk">{{ group.experience }}</span>
                </span>
              </div>
            </div>
            <div class="job_opening_card_preview_block job-sphere">
              <div class="job_opening_card_preview_block-title">
                <span is="i18n">
                  <span lang="ru">Сфера</span>
                  <span lang="en">Sphere</span>
                  <span lang="kk">Саласы</span>
                </span>
              </div>
              <div class="job_opening_card_preview_block-subtext">
                <span is="i18n">
                  <span lang="kk">{{ group.area }}</span>
                </span>
              </div>
            </div>
            <button class="btn job_opening_card_preview_button" @click="toggleExpansion(key)">
              <span v-if="!groups_localized[key].active" is="i18n">
                <span lang="ru">Подробнее</span>
                <span lang="en">More</span>
                <span lang="kk">Толығырақ</span>
              </span>
              <span v-else is="i18n">
                <span lang="ru">Скрыть</span>
                <span lang="en">Hide</span>
                <span lang="kk">Жасыру</span>
              </span>
            </button>
          </div>
          <div class="job_openings_content" :class="{ active: groups_localized[key].active }">
            <div class="job_openings_content_requirements">
              <div class="row">
                <div class="job_openings_content_requirements-block">
                  <div class="job_openings_content_requirements-text-load">
                    <div class="job_openings_content_requirements-title">
                      <span is="i18n">
                        <span lang="ru">Занятость:</span>
                        <span lang="en">Workload:</span>
                        <span lang="kk">Жұмыспен қамту:</span>
                      </span>
                    </div>
                    <div class="job_openings_content_requirements-subtitle">
                      <span is="i18n">
                        <span lang="kk">{{ group.content.load }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="job_openings_content_requirements-text-exp">
                    <div class="job_openings_content_requirements-title">
                      <span is="i18n">
                        <span lang="ru">Опыт работы:</span>
                        <span lang="en">Work experience:</span>
                        <span lang="kk">Жұмыс тәжірибесі:</span>
                      </span>
                    </div>
                    <div class="job_openings_content_requirements-subtitle">
                      <span is="i18n">
                        <span lang="kk">{{ group.experience }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="job_openings_content_requirements-text-status">
                    <div class="job_openings_content_requirements-title">
                      <span is="i18n">
                        <span lang="ru">Статус:</span>
                        <span lang="en">Status:</span>
                        <span lang="kk">Күйі:</span>
                      </span>
                    </div>
                    <div class="job_openings_content_requirements-subtitle">
                      <span is="i18n">
                        <span lang="kk">{{ group.status }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="job_openings_content_requirements-block job_content-requirements">
                  <div class="job_openings_content_requirements-title">
                    <span is="i18n">
                      <span lang="ru">Требования:</span>
                      <span lang="en">Requirements:</span>
                      <span lang="kk">Талаптар:</span>
                    </span>
                  </div>
                  <ul class="job_openings_content_requirements-list">
                    <li
                      class="job_openings_content_requirements-item"
                      v-for="(item, idx) in group.content.requirements"
                      :key="idx"
                    >
                      <span is="i18n">
                        <span lang="kk">{{ item }}</span>
                      </span>
                    </li>
                  </ul>
                </div>
                <div class="job_openings_content_requirements-block job_content-conditions">
                  <div class="job_openings_content_requirements-title">
                    <span is="i18n">
                      <span lang="ru">Условия:</span>
                      <span lang="en">Conditions:</span>
                      <span lang="kk">Шарттары:</span>
                    </span>
                  </div>
                  <ul class="job_openings_content_requirements-list">
                    <li
                      class="job_openings_content_requirements-item"
                      v-for="(item, idx) in group.content.requirements"
                      :key="idx"
                    >
                      <span is="i18n">
                        <span lang="kk">{{ item }}</span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <router-link to="/contacts" class="btn job_openings_content-button">
                <span is="i18n">
                  <span lang="ru">Откликнуться</span>
                  <span lang="en">Respond</span>
                  <span lang="kk">Жауап қайтару</span>
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="selection_process">
      <div class="selection_process-title">
        <div class="selection_process-text">
          <span is="i18n">
            <span lang="ru">Процесс отбора</span>
            <span lang="en">Selection process</span>
            <span lang="kk">Іріктеу процесі</span>
          </span>
        </div>
      </div>
      <div class="selection_process-image"></div>
      <div class="selection_process-steps">
        <div class="row">
          <div class="selection_process_step step_curriculum-vitae">
            <div class="selection_process_step-image">
              <img src="@/assets/images/curriculum-vitae.svg" alt="Резюме" />
            </div>
            <div class="selection_process_step-title">
              <span is="i18n">
                <span lang="ru">Рассмотрение резюме</span>
                <span lang="en">CV review</span>
                <span lang="kk">Резюмені қарау</span>
              </span>
            </div>
            <div class="selection_process_step-text">
              <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed</span>
            </div>
          </div>
          <div class="selection_process_step step_job-interview">
            <div class="selection_process_step-image">
              <img src="@/assets/images/job-interview.svg" alt="Резюме" />
            </div>
            <div class="selection_process_step-title">
              <span is="i18n">
                <span lang="ru">Интервью</span>
                <span lang="en">Interview</span>
                <span lang="kk">Сұхбат</span>
              </span>
            </div>
            <div class="selection_process_step-text">
              <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed</span>
            </div>
          </div>
          <div class="selection_process_step step_test">
            <div class="selection_process_step-image">
              <img src="@/assets/images/test.svg" alt="Резюме" />
            </div>
            <div class="selection_process_step-title">
              <span is="i18n">
                <span lang="ru">Тестовое задание</span>
                <span lang="en">Test task</span>
                <span lang="kk">Тест тапсырмасы</span>
              </span>
            </div>
            <div class="selection_process_step-text">
              <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed</span>
            </div>
          </div>
          <div class="selection_process_step step_job-accepted">
            <div class="selection_process_step-image">
              <img src="@/assets/images/job.svg" alt="Резюме" />
            </div>
            <div class="selection_process_step-title">
              <span is="i18n">
                <span lang="ru">Вы приняты!</span>
                <span lang="en">You are accepted!</span>
                <span lang="kk">Сіз қабылдандыңыз!</span>
              </span>
            </div>
            <div class="selection_process_step-text">
              <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed</span>
            </div>
          </div>
        </div>
      </div>
      <div class="selection_process_link">
        <router-link to="/contacts" class="btn contact_button">
          <span is="i18n">
            <span lang="ru">Связаться</span>
            <span lang="en">Contact</span>
            <span lang="kk">Байланысу</span>
          </span>
        </router-link>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="page_title">
      <div class="page_title-text">
        <span is="i18n">
          <span lang="ru">Свободных вакансий нет</span>
          <span lang="en">There are no vacancies</span>
          <span lang="kk">Бос орындар жоқ</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import groups_ru from '../translations/groups_ru.js';
import groups_en from '../translations/groups_en.js';
import groups_kk from '../translations/groups_kk.js';

export default {
  name: 'Career',
  data: () => ({
    groups: {
      ru: groups_ru,
      en: groups_en,
      kk: groups_kk,
      qz: groups_kk,
    },
  }),
  computed: {
    lang() {
      return this.$store.getters.lang;
    },
    groups_localized() {
      return this.groups[this.lang];
    },
  },
  methods: {
    toggleExpansion(key) {
      this.groups_localized[key].active = !this.groups_localized[key].active;
    },
  },
};
</script>

<style lang="scss" scoped>
.job_openings {
  margin-top: 50px;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: column;
  transition: all 0.5s;
}

.job_opening_card {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #d7d7d7;
  margin: 10px auto;
  align-items: center;
  width: 100%;
}

.job_opening_card.active {
  border: 1px solid #00aaff;
  border-radius: 3px 3px 0px 0px;
}

.job_opening_card_preview {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  padding: 30px;
}

.job_opening_card_preview-image {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 0;
  margin-right: 55px;
}

.job_openings_card-image > img {
  min-width: 42px;
}

.job_opening_card_preview_block {
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  width: 15%;
}

.job_opening_card_preview_block-main {
  margin-right: auto;
  margin-left: 0;
  max-width: 200px;
}

.job_opening_card_preview_block-main > .job_opening_card_preview_block-title {
  font-size: 18px;
  line-height: 22px;
}

.job-status {
  width: 90px;
}

.job_opening_card_preview_block-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  color: #555555;
  margin-bottom: 6.5px;
}

.job_opening_card_preview_block-subtext {
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #bcbcbc;
  margin-top: 6.5px;
  overflow: hidden;
  max-width: 100%;
  min-height: 33px;
}

.job_opening_card_preview_block-main > .job_opening_card_preview_block-subtext {
  max-width: 205px;
}

.job_opening_card_preview_button {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px;
  margin-right: 30px;
  background: #f0f0f0;
  height: 36px;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #555555;
  padding: 8px 20px 9px;
  margin-right: 0;
}

.job_opening_card_preview_button:hover,
.job_opening_card_preview_button:active {
  background: #dbdbdb;
  transition: all 0.1s;
}

.job_openings_content {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid #d7d7d7;
  max-height: 0;
  overflow: hidden;
  transition: all 0.8s;
  max-height: 0;
  border: none;
}

.job_openings_content.active {
  max-height: 853px;
}

.job_openings_content_requirements {
  padding: 30px;
  color: #555555;
}

.job_openings_content_requirements-block {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: column;
  -ms-flex: 0 0 33.333333%;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.job_openings_content_requirements-list {
  max-width: 300px;
}

.job_openings_content_requirements-item {
  font-size: 16px;
  line-height: 19px;
  color: #555555;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  white-space: pre-wrap;
}

.job_openings_content_requirements-item::before {
  content: '- ';
}

.job_openings_content_requirements-text-load {
  margin-bottom: 10px;
}

.job_openings_content_requirements-text-exp {
  margin-top: 10px;
  margin-bottom: 10px;
  display: none;
}

.job_openings_content_requirements-text-status {
  margin-top: 10px;
  display: none;
}

.job_openings_content_requirements-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 23px;
  margin-bottom: 5px;
}

.job_openings_content_requirements-subtitle {
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  max-width: 230px;
}

.job_openings_content-button {
  width: 130px;
  min-height: 36px;
  background: #00aaff;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 0 auto;
}

.job_openings_content-button:hover {
  background: #029deb;
  transition: all 0.1s;
}

.selection_process-steps {
  position: relative;
  margin-right: auto;
  margin-left: auto;
}

.selection_process {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: column;
}

.selection_process-title {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 70px auto 60px;
}

.selection_process-text {
  margin-left: auto;
  margin-right: auto;
  font-weight: bold;
  font-size: 28px;
  line-height: 29px;
  color: #555555;
}

.selection_process-image {
  margin-bottom: 15px;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: row;
  background: url('../assets/images/selection_process.svg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position-x: center;
  height: 129px;
}

.selection_process_step {
  overflow: hidden;
  margin-top: 15px;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: column;
  width: 195px;
  /* border: 1px solid #555555; */
  margin-left: auto;
  margin-right: auto;
}

.step_curriculum-vitae {
  margin-left: 0 !important;
}

.step_job-accepted {
  margin-right: 0 !important;
}

.selection_process_step-image {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  margin-bottom: 15px;
}

.selection_process_step-title {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  font-weight: bold;
  font-size: 16px;
  line-height: 100%;
  color: #555555;
  margin-bottom: 5px;
}

.selection_process_step-text {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #555555;
  margin-top: 5px;
}

.selection_process_link {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 80px auto 0;
}

.selection_process_link > a.btn.contact_button {
  background-color: #00aaff;
  border-radius: 1px;
  color: #ffffff;
}

.selection_process_link > a.btn.contact_button:hover,
.selection_process_link > a.btn.contact_button:active {
  background: #029deb !important;
  transition: all 0.1s;
}

@media (max-width: 1324px) {
  .selection_process-steps {
    display: -webkit-flex;
    display: -moz-box;
    display: -webkit-flex;
    display: -moz-box;
    display: flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    margin-left: 0;
    margin-right: 0;
  }
  .selection_process-image {
    width: 94%;
  }
  .selection_process_step {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
    margin-left: auto;
    margin-right: auto;
    min-width: 200px;
  }
}

@media (max-width: 1140px) {
  .job-sphere {
    display: none;
  }
  .selection_process-image {
    display: none;
  }
  .selection_process_step {
    padding: 20px;
    border: 0.5px solid #b3b3b3;
    border-radius: 5px;
  }
}

@media (max-width: 1035px) {
  .selection_process_step {
    -ms-flex: 0 0 35%;
    flex: 0 0 35%;
    max-width: 35%;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .selection_process_step:nth-child(2n-1) {
    margin-right: 20px !important;
    margin-left: auto !important;
  }
  .selection_process_step:nth-child(2n) {
    margin-left: 20px !important;
    margin-right: auto !important;
  }
  .step_curriculum-vitae,
  .step_job-interview {
    margin-bottom: 20px;
    margin-top: 0 !important;
  }
  .step_test,
  .step_job-accepted {
    margin-top: 20px;
  }
  .selection_process_step-image > img,
  .selection_process_step-title,
  .selection_process_step-text {
    margin-left: auto !important;
    margin-right: auto !important;
    text-align: center;
  }
}

@media (max-width: 900px) {
  .job-exp {
    display: none;
  }
  .job_openings_content_requirements-text-exp {
    display: block;
  }
  .job_openings_content_requirements-block {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .job_content-conditions {
    display: none;
  }
  .selection_process-title {
    margin: 60px auto 40px;
  }
}

@media (max-width: 780px) {
  .job_openings {
    margin-top: 20px;
  }
  .job-status {
    display: none;
  }
  .job_openings_content_requirements-text-status {
    display: block;
  }
  .job_opening_card_preview {
    padding: 20px;
  }
  .job_openings_content_requirements {
    padding: 20px;
    color: #555555;
  }
}

@media (max-width: 576px) {
  .job_opening_card_preview-image {
    margin-left: 0 !important;
    margin-top: 0 !important;
    margin-right: auto !important;
  }
  .job_opening_card_preview_block-main {
    margin-right: 0;
    margin-left: auto;
  }
  .job_openings_content-button {
    margin-left: auto;
    margin-right: auto;
  }
  .job_opening_card_preview_block-main {
    margin-left: 14px;
    margin-right: auto;
  }
  .job_opening_card_preview_block-subtext {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .job_opening_card_preview_button {
    margin-left: auto;
    margin-right: auto;
  }
  .job_openings_content_requirements-block {
    -ms-flex: 0 0 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .job_openings_content_requirements-block {
    margin-bottom: 20px;
  }
  .job_content-conditions {
    display: block !important;
  }
  .selection_process_step:nth-child(n) {
    -ms-flex: 0 0 80%;
    flex: 0 0 80%;
    max-width: 80%;
    min-height: 200px;
    height: auto !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .selection_process_step.step_job-interview {
    margin-bottom: 0 !important;
  }
  .selection_process_step-text {
    margin-top: 20px;
    max-width: 200px;
  }
}

@media (max-width: 353px) {
  .job_opening_card_preview-image,
  .job_opening_card_preview_block-main {
    margin-right: auto !important;
    margin-left: auto !important;
    display: -webkit-flex;
    display: -moz-box;
    display: -webkit-flex;
    display: -moz-box;
    display: flex;
    flex-direction: column;
  }
  .job_opening_card_preview-image {
    margin-bottom: 10px;
  }
  .job_opening_card_preview_block-title,
  .job_opening_card_preview_block-subtext {
    max-width: 200px;
  }
}

@media (min-width: 1325px) {
  .step_curriculum-vitae {
    margin-right: 80px;
  }
  .step_job-interview {
    margin-left: 57px;
    margin-right: 63.5px;
  }
  .step_test {
    margin-left: 63.5px;
    margin-right: 37.5px;
  }
  .step_job-accepted {
    margin-left: 37.5px;
  }
}
</style>
